import { render, staticRenderFns } from "./CreateCertificateModal.vue?vue&type=template&id=50929c26&scoped=true&"
import script from "./CreateCertificateModal.vue?vue&type=script&lang=js&"
export * from "./CreateCertificateModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateCertificateModal.vue?vue&type=style&index=0&id=50929c26&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50929c26",
  null
  
)

export default component.exports